// src/components/admin/PricingManager.js
import { useState, useEffect } from 'react';
import { FiSave, FiDollarSign } from 'react-icons/fi';
import { useApiAuth } from '../../hooks/useApiAuth';
import { useServices } from '../../hooks/useServices';

function PricingManager() {
  const { services, refresh } = useServices();
  const { authFetch } = useApiAuth();
  const [packages, setPackages] = useState([]);
  const [addons, setAddons] = useState([]);
  const [monthlyFee, setMonthlyFee] = useState(75);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (services.packages) setPackages(services.packages);
    if (services.addons) setAddons(services.addons);
    if (services.monthlyFee) setMonthlyFee(services.monthlyFee);
  }, [services]);

  function updatePackagePrice(idx, value) {
    setPackages(prev => prev.map((p, i) => i === idx ? { ...p, price: Number(value) } : p));
  }

  function updatePackageDisplay(idx, value) {
    setPackages(prev => prev.map((p, i) => i === idx ? { ...p, priceDisplay: value || undefined } : p));
  }

  function updateAddonPrice(idx, value) {
    setAddons(prev => prev.map((a, i) => i === idx ? { ...a, price: Number(value) } : a));
  }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      await authFetch('/api/admin/services', {
        method: 'PUT',
        body: { packages, addons, monthlyFee },
      });
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      alert('Failed to save: ' + err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="admin-section">
      <h2 className="admin-section-title">Service Pricing</h2>
      <form className="admin-form" onSubmit={handleSave}>
        <h3 className="admin-form-subtitle">Monthly Fee</h3>
        <div className="admin-field">
          <label className="admin-label"><FiDollarSign size={14} /> Monthly Subscription</label>
          <input className="admin-input admin-input--short" type="number" min="0" value={monthlyFee} onChange={e => setMonthlyFee(Number(e.target.value))} />
        </div>

        <h3 className="admin-form-subtitle">Packages</h3>
        {packages.map((pkg, i) => (
          <div className="admin-field-row" key={pkg.id}>
            <span className="admin-field-label">{pkg.name}</span>
            <div className="admin-field-pair">
              <label className="admin-label-sm">Price ($)</label>
              <input className="admin-input admin-input--short" type="number" min="0" value={pkg.price} onChange={e => updatePackagePrice(i, e.target.value)} />
            </div>
            <div className="admin-field-pair">
              <label className="admin-label-sm">Display text</label>
              <input className="admin-input admin-input--short" type="text" placeholder="e.g. $500+" value={pkg.priceDisplay || ''} onChange={e => updatePackageDisplay(i, e.target.value)} />
            </div>
          </div>
        ))}

        <h3 className="admin-form-subtitle">Add-ons</h3>
        {addons.map((addon, i) => (
          <div className="admin-field-row" key={addon.id}>
            <span className="admin-field-label">{addon.label}</span>
            <div className="admin-field-pair">
              <label className="admin-label-sm">Price ($)</label>
              <input className="admin-input admin-input--short" type="number" min="0" value={addon.price} onChange={e => updateAddonPrice(i, e.target.value)} />
            </div>
          </div>
        ))}

        <button className="admin-save-btn" type="submit" disabled={saving}>
          <FiSave size={14} />
          {saving ? 'Saving…' : saved ? 'Saved!' : 'Save Pricing'}
        </button>
      </form>
    </section>
  );
}

export default PricingManager;
